/** QuickPlan — Bouton « Exporter en STL (.stl) » pour l'impression 3D : les pièces
 *  sélectionnées, sinon tout l'assemblage visible (cf. src/export/stl.js). */
import { useState } from 'react';
import { useProjectStore } from '../store/useProjectStore.js';
import { buildStl } from '../export/stl.js';
import { fmt } from '../geom.js';

export default function ExportStlButton({ className = '', label = '⤓ Exporter en STL (.stl)' }) {
  const project = useProjectStore((s) => s.project);
  const count = useProjectStore((s) => s.selection.length);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const st = useProjectStore.getState();
    setBusy(true);
    try {
      await new Promise((r) => setTimeout(r, 0)); // laisse le bouton afficher « … »
      const { buffer, fileName, instances, triangles, size } = buildStl(st.project, st.lookup(), { ids: st.selection });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([buffer], { type: 'model/stl' }));
      a.download = fileName;
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
      st.setStatus(`Exporté : ${fileName} — ${instances} pièce(s), ${size.map((v) => fmt(v)).join(' × ')} mm, ${triangles.toLocaleString('fr-FR')} triangles`);
    } catch (e) {
      st.setStatus(`⚠ Export STL impossible : ${e.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      className={className}
      disabled={busy || !project?.instances.length}
      onClick={run}
      title={`${count ? `Les ${count} pièce(s) sélectionnée(s)` : "Tout l'assemblage visible (sélectionnez des pièces pour n'exporter qu'elles)"} en maillage fermé pour l'impression 3D — mm, Z vers le haut, posé sur le plateau et centré`}
    >
      {busy ? '…' : count ? `${label} · ${count}` : label}
    </button>
  );
}
